import { styled } from '@mui/material/styles';
import MuiChip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@components/Typography';

export const TagDot = styled('span', {
    shouldForwardProp: prop => prop !== 'color' && prop !== 'size',
})(({ color, size = 8 }) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    flex: 'none',
    backgroundColor: color,
}));

const StyledTagChip = styled(MuiChip, {
    shouldForwardProp: prop => prop !== 'tagColor',
})(({ tagColor }) => ({
    backgroundColor: `${tagColor}59`,
    borderRadius: 8,
    color: 'var(--text-primary)',
    padding: '3px 6px',
    height: 20,
    maxWidth: 140,
    '&:hover': {
        backgroundColor: `${tagColor}59`,
    },
    '& .MuiChip-label': {
        padding: 0,
        height: 14,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
    },
    '& .MuiChip-deleteIcon': {
        width: 13,
        height: 13,
        color: 'var(--text-secondary)',
        margin: '0 0 0 4px',
    },
}));

export const TagChip = ({ name, color, onDelete }) => (
    <StyledTagChip
        tagColor={color}
        label={
            <Typography variant="caption" noWrap sx={{ display: 'block' }}>
                {name}
            </Typography>
        }
        deleteIcon={<CloseIcon />}
        onDelete={onDelete}
    />
);
